import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'site-modules/shared/components/link/link';
import { useUrlFilterSync } from 'client/site-modules/lease-deals/hooks/use-url-filter-sync/use-url-filter-sync';
import { FILTER_QUERY_PARAMS, DEALS_FILTER_VALUES } from 'client/site-modules/shared/constants/lease-deals/lease-deals';
import { LOW_INVENTORY_BUTTON_VARIANTS } from 'client/site-modules/lease-deals/constants/lease-deals-constants';
import { SelectedFilters } from 'client/site-modules/lease-deals/constants/prop-types';
import { createSrpUrl } from 'client/site-modules/lease-deals/utils/lease-deals-url-utils';

import './low-inventory-options.scss';

export function LowInventoryOptions({ currentTab = DEALS_FILTER_VALUES.ALL, selectedFilters = {}, setModelValue }) {
  const onUpdate = useUrlFilterSync(setModelValue);

  const actionHandlers = useMemo(
    () => ({
      onViewAllSpecials: () => onUpdate({ [FILTER_QUERY_PARAMS.DEALS]: [DEALS_FILTER_VALUES.ALL] }),
      onClearAllFilters: () => onUpdate({}, true),
    }),
    [onUpdate]
  );

  const handleButtonClick = useCallback(
    buttonConfig => {
      requestAnimationFrame(() => {
        actionHandlers[buttonConfig.action]?.();
      });
    },
    [actionHandlers]
  );

  const buttonConfigs = LOW_INVENTORY_BUTTON_VARIANTS.filter(config => config.tabsDisplayedOn.includes(currentTab));

  return (
    <div className="low-inventory-options">
      <div>
        {buttonConfigs.map(buttonConfig => {
          const Component = buttonConfig.tag === 'a' ? Link : 'button';

          const linkProps =
            buttonConfig.tag === 'a'
              ? { to: createSrpUrl(selectedFilters) }
              : { onClick: () => handleButtonClick(buttonConfig) };

          return (
            <Component
              key={buttonConfig.id}
              className="low-inventory-options-button d-flex align-items-center flex-grow-1 gap-0_75 bg-white shadow-sm border mt-1 mx-auto px-1 py-0_75 rounded-2 text-gray-dark"
              data-tracking-id={buttonConfig.trackingEvent.trackingId}
              data-tracking-value={buttonConfig.trackingEvent.value}
              {...linkProps}
            >
              <span className="link-icon rounded-circle d-flex justify-content-center align-items-center text-blue-50 bg-blue-100">
                <i className={`icon ${buttonConfig.icon}`} aria-hidden />
              </span>
              <span className="text-decoration-none flex-grow-1 text-start text-gray-dark fw-bold size-14">
                {buttonConfig.text}
              </span>
              <i className="size-14 icon icon-arrow-right3 text-blue-30" aria-hidden />
            </Component>
          );
        })}
      </div>
    </div>
  );
}

LowInventoryOptions.propTypes = {
  currentTab: PropTypes.oneOf([DEALS_FILTER_VALUES.ALL, DEALS_FILTER_VALUES.GEMS]),
  selectedFilters: SelectedFilters,
  setModelValue: PropTypes.func.isRequired,
};
